export default "__VITE_ASSET__Bzp4YHuP__"